import "../CSS/confirm-delete.css";

const ConfirmDeleteUser = ({ handleOk, handleCancel, loading }) => {
  return (
    <div className="bv-confirm-delete-user">
      <header>
        <h4>Confirm Delete</h4>
      </header>

      <div className="body">
        <p>Do you want to proceed with deleting this record?</p>
      </div>

      <div className="actions">
        <button onClick={handleOk}>{loading ? "..." : "Continue"}</button>

        <button onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default ConfirmDeleteUser;
